import { UIText2 } from '@cian/ui-kit';
import { IconProductSalesStart12 } from '@cian/ui-kit-design-tokens/icons';

import * as styles from './SalesStartLabel.css';

export const SalesStartLabel = () => {
  return (
    <div>
      <UIText2>Старт продаж</UIText2>
      <span className={styles['icon']}>
        <IconProductSalesStart12 color="icon-negative-default" />
      </span>
    </div>
  );
};
